<template>
	<div id="rating-table">
		<div style="min-height:400px;">
			<div
				v-for="item in ratings"
				:key="item.id"
				class="d-sm-flex align-center"
				:class="{
					'py-2': userDevice === 'desktop',
					'py-3': userDevice === 'mobile',
				}"
				style="border-bottom:1px solid #ddd;"
			>
				<div class="d-none d-sm-block" style="width:55px;">
					{{ item.kakaoId.slice(0, 5) }}
				</div>
				<div class="d-flex align-center">
					<v-rating
						background-color="yellow darken-2"
						color="yellow darken-2"
						class="mr-1"
						readonly
						dense
						small
						half-increments
						v-model="item.score"
					></v-rating>
					<strong class="d-block d-sm-none font-wieght-bold">{{
						item.score
					}}</strong>
				</div>
				<div
					:style="userDevice === 'desktop' ? 'width:70px;' : ''"
					class="text-body-2 text-left grey--text text--dakren-1"
					:class="{
						'mt-1': userDevice === 'mobile',
						'px-2': userDevice === 'desktop',
					}"
				>
					<span class="d-inline-block d-sm-none">
						{{ item.kakaoId.slice(0, 5) }}
						<span class="px-3">|</span>
					</span>
					{{ createdTime(item.created_at) }}
					<span class="d-inline-block d-sm-none">
						<span class="px-3">|</span>
						Tutor {{ item.tutor_name }}
					</span>
				</div>

				<div
					:style="userDevice === 'desktop' ? 'width:calc(100% - 300px);' : ''"
					class="text-body-2 text-truncate text-left"
					:class="{ 'mt-3': userDevice === 'mobile' }"
					v-if="item.reason"
				>
					<span
						class="mr-3 d-none d-sm-inline-block"
						v-if="$route.name !== 'tutor-detail'"
						>[Tutor {{ item.tutor_name }}]</span
					>
					<img
						class="d-inline-block"
						width="13"
						src="@/assets/img/reviews/comment.png"
						alt=""
					/>
					{{ item.reason }}
				</div>
			</div>
		</div>

		<!-- <v-data-table
			:style="`background-color:${backgroundColor};`"
			:loading="isLoading"
			:items="ratings"
			hide-default-footer
			:items-per-page="itemsPerPage"
		>
			<template v-slot:body="{ items }">
				<tbody>
					<tr
						v-for="item in items"
						:key="item.id"
						class="table-tr"
						style="line-height: 1rem;"
					>
						<td class="py-3">
							<div class="d-flex align-center">
								<div style="width:55px;">
									{{ item.kakaoId.slice(0, 5) }}
								</div>
								<v-rating
									background-color="yellow darken-2"
									color="yellow darken-2"
									class="mr-1"
									readonly
									dense
									small
									half-increments
									v-model="item.score"
								></v-rating>
								<div
									class="px-1 text-body-2 grey--text text--dakren-1"
									style="width:60px;"
								>
									{{ createdTime(item.created_at) }}
								</div>
								<div
									style="width:calc(100% - 500px);"
									class="text-body-1 text-truncate"
									v-if="item.reason"
								>
									<img
										class="d-inline-block"
										width="15"
										src="@/assets/images/reviews/comment.png"
										alt=""
									/>
									{{ item.reason }}
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</template>
		</v-data-table> -->
		<div class="text-center pt-8">
			<v-pagination
				style="font-size:1rem!important;"
				:color="color"
				v-model="page"
				:length="totalPages"
				:total-visible="7"
			></v-pagination>
		</div>
	</div>
</template>

<script>
import lessonRatingService from '@/services/lesson-rating'
import moment from 'moment-timezone'
import format from '@/mixins/format'

export default {
	props: {
		backgroundColor: {
			type: String,
			default: '#fff',
			required: false,
		},
		tutorId: {
			type: Number,
			default: null,
		},
		gtScore: {
			type: Number,
			default: 0,
		},
		active: {
			type: Number,
			default: 1,
		},
		itemsPerPage: {
			type: Number,
			default: 10,
		},
		color: {
			type: String,
			default: 'primary',
		},
	},
	data: () => ({
		isLoaded: false,
		isLoading: false,
		ratings: [],
		page: 1,
		totalPages: 0,
	}),
	computed: {
		conditionQuery() {
			let query = ``
			if (this.tutorId) query = `${query}&tutor_id=${this.tutorId}`
			if (this.gtScore !== null) query = `${query}&gt_score=${this.gtScore}`
			if (this.active) query = `${query}&active=${this.active}`
			return query
		},
		userDevice() {
			return this.$store.getters['userDevice']
		},
	},
	watch: {
		page() {
			this.getRatings(false)
		},
	},
	created() {
		this.getRatings(true)
	},
	methods: {
		async getRatings(isCount) {
			this.isLoaded = false
			this.isLoading = true
			if (isCount) {
				this.totalPages = 0
				this.page = 1
			}
			let offset = (this.page - 1) * this.itemsPerPage
			let countQuery = `?is_count=true`
			let query = `?limit=${this.itemsPerPage}&offset=${offset}&order_by=id&order_method=desc`
			if (this.conditionQuery !== ``) {
				countQuery = countQuery + this.conditionQuery
				query = query + this.conditionQuery
			}

			let promises = [
				lessonRatingService.getWithMembersAndTutorsAndPrograms(query),
			]
			if (isCount === true) {
				promises.push(
					lessonRatingService.getWithMembersAndTutorsAndPrograms(countQuery),
				)
			}

			const [ratings, counts] = await Promise.all(promises)

			this.ratings = ratings
			if (isCount === true) {
				this.totalPages = Math.ceil(counts[0].count / this.itemsPerPage)
			}
			this.isLoaded = true
			this.isLoading = false
		},
		createdTime(createdAt) {
			const createdMoment = moment.tz(createdAt, 'Asia/Seoul')
			const dayDiff = moment().diff(createdMoment, 'days')
			return dayDiff > 365
				? `${Math.floor(dayDiff / 365)}년 전`
				: dayDiff > 30
				? `${Math.floor(dayDiff / 30)}개월 전`
				: dayDiff > 7
				? `${Math.floor(dayDiff / 7)}주 전`
				: dayDiff > 2
				? `${dayDiff}일 전`
				: dayDiff === 2
				? '어제'
				: '오늘'
		},
	},
	mixins: [format],
}
</script>

<style>
#rating-table .v-rating--dense .v-icon {
	padding: 0;
}
</style>
